
const utils = {
  getHost(isMember) {
    const hostname = location.hostname;
    const apiType = hostname.indexOf('test') !== -1 ? 'test' : 'dev';
    if (hostname === 'localhost' || /^10\./.test(hostname) || /local\./.test(hostname)) {
      return isMember ? `http://member.${apiType}.zlgx.com` : `http://sso.${apiType}.zlgx.com`;
      // return `https://${isMember ? 'member' : 'sso'}.zlgx.com`
    } else {
      return isMember ? `${location.protocol}//${location.host.replace('sso', 'member')}` : `${location.protocol}//${location.host}`;
    }
  },
  getRootDomain() {
    const root = location.hostname.match(/\.[a-z]+\.(cc|com|cn)/)
    return root ? root[0] : location.hostname
  },
  env() {
    return process.env.NODE_ENV;
  },
  isProd() {
    return utils.env() === 'production';
  },
}

export default utils; 